import React, { useCallback, useEffect } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  PopoverProps
} from '@material-ui/core';
import { contextMenuContext } from '@cube3/cubicle/src/core/molecules/ContextualMenu/ContextualMenuPopoverUI';
import useOutsideClick from '@cube3/cubicle/src/helpers/hooks/UseOutsideClick';
import { ContextMenu } from '@cube3/cubicle/src/core/molecules/ContextMenu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    }
  })
);

// pick open property from PopoverInterface
type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type ExcludedPopoverProps = Omit<PopoverProps, 'open'>;

interface MenuListCompositionProps {
  toggleButton(
    handleToggle: () => void,
    anchorEl: React.MutableRefObject<HTMLElement>,
    open: boolean
  ): React.ReactNode;
  visible?: boolean;
  variant?: 'legacy' | 'context-menu';
  menuItems: React.ReactNode | (() => React.ReactNode);
  onClose?(): void;
  PopoverProps?: ExcludedPopoverProps;
}

function MenuListComposition(props: MenuListCompositionProps) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorEl = React.useRef<HTMLElement>(null);

  const handleToggle = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const {
    toggleButton,
    menuItems,
    onClose,
    variant = 'legacy',
    visible = true
  } = props;

  const closeHandler = useCallback(
    (ev) => {
      setOpen(false);
    },
    [setOpen]
  );

  useEffect(() => {
    if (open && !visible) {
      setOpen(false);
    }
  }, [visible, setOpen, open]);

  if (!menuItems) {
    console.warn('Empty menu rendered');
  }

  const outsideRef = useOutsideClick(closeHandler);

  // if (typeof menuItems !== 'function') {
  //   console.warn('Menuitems is not a function', menuItems);
  // }

  if (!visible) {
    return null;
  }

  if (variant === 'legacy') {
    return (
      <div className={classes.root}>
        {toggleButton(handleToggle, anchorEl, open)}

        {open && (
          <div ref={outsideRef} onClick={closeHandler}>
            <ContextMenu
              anchor={anchorEl.current}
              scrollbarHeight={200}
              width={'100%'}
            >
              {menuItems &&
                (typeof menuItems === 'function' ? menuItems() : menuItems)}
            </ContextMenu>
          </div>
        )}
      </div>
    );
  } else if (variant === 'context-menu') {
    return (
      <div className={classes.root}>
        {toggleButton(handleToggle, anchorEl, open)}

        {open && (
          <contextMenuContext.Provider
            value={{
              clientX: anchorEl.current?.getBoundingClientRect().left,
              clientY: anchorEl.current?.getBoundingClientRect().bottom,
              menuOpen: open,
              handleClose: closeHandler,
              handleClearAll: onClose
            }}
          >
            {menuItems && typeof menuItems === 'function' && menuItems()}
            {/* </Popover> */}
          </contextMenuContext.Provider>
        )}
      </div>
    );
  }
}

export default MenuListComposition;
